<template>
    <div>
      <div>
        <v-file-input v-model="file"
                      :disabled="progress"
                      :accept="acceptedFiles"
                      :label="fileInputLabel">
        </v-file-input>
      </div>

      <div>
        <load-progress :condition="progress" :label="progressLabel"></load-progress>
      </div>

      <div v-if="errorMsg.length > 0">
        <div v-for="info in errorMsg" :key="info" class="grey lighten-2 p-0">
          <div class="text-h9">- {{ info }}</div>
        </div>
      </div>

      <div class="d-flex flex-row-reverse mt-4">
        <loader-button class="ms-2"
                       :label="buttonClose"
                       @callback="closeDialog">
        </loader-button>
        <loader-button class="ms-2"
                       :label="buttonAction"
                       @callback="submitFile"
                       :disabled="!file || progress">
        </loader-button>
      </div>
    </div>
</template>

<script lang="ts">
import LoaderButton from '@/framework/base/components/LoaderButton.vue';
import LoadProgress from '@/framework/base/components/LoadProgress.vue';
import { Alerts } from '@/framework/base/helpers/Alerts';
import { AdminImport } from '@/generated/classes/Admin';
import Files from '@/generated/classes/Files';
import { mimeTypes } from '@/framework/files/helpers/FileTypes'
import { FwkButtons, RessourceFwkButton } from '@/ressources/globalRessources';
import HubServices from "@/generated/hub/HubServices";
import { defineComponent, PropType } from "vue";

export default defineComponent({
  components: {
    LoadProgress,
    LoaderButton
  },
  props: {
    showDialog: {
      type: Boolean
    },
    config: {
      type: Object as PropType<AdminImport>,
      required: true
    }
  },
  created() {
    HubServices.onFilesProgress(this.setProgress);
  },
  data() {
    const errorMsg: string[] = [];
    const file: File | null = null;

    return {
      fileInputLabel: 'Choisir un fichier',
      progressLabel: "Changement en cours",
      progress: false,
      register: false,
      file,
      errorMsg,
      buttonAction: RessourceFwkButton(FwkButtons.IMPORTER).label,
      buttonClose: RessourceFwkButton(FwkButtons.FERMER).label
    };
  },
  computed: {
    acceptedFiles(): string {
      let res = ''
      mimeTypes.forEach(m => {
        if (res != '') {
          res += ',';
        }
        res += m.mime;
      })
      return res;
    }
  },

  methods: {
    setProgress(value: string) {
      this.progressLabel = value;
    },
    closeDialog() {
      this.file = null;
      this.errorMsg = [];
      this.progress = false;

      this.$emit('closeDialog');
    },
    submitFile(): void {
      if (this.file != null) {
        this.progress = true;
        const formData = new FormData()
        formData.append('file', this.file);
        formData.append('service', this.config.service);
        formData.append('table', this.config.table);
        formData.append('mode', this.config.mode.toString());
        Files.upload(formData).then((res) => {
          this.progress = false;
          this.file = null;
          if (res != null) {
            this.$emit('updated');
            Alerts.message(res);
          }
        });
      }
    }
  }
})

</script>

<style scoped>
</style>


